import { Product, ProductSizes } from "../../../gobalType";

type SizeWithRetail = ProductSizes & {
  is_retail_product?: number | string | boolean;
};

type ThumbnailRow = NonNullable<Product["thumbnail"]>[number] & {
  size_id?: number | null;
  is_default?: number | null;
};

function isRetailSize(s: ProductSizes): boolean {
  const v = (s as SizeWithRetail).is_retail_product;
  return v === 1 || v === "1" || v === true;
}

/** Ưu tiên size retail; không có thì phần tử đầu (đúng thứ tự API). */
export function pickPrimaryProductSize(
  sizes: ProductSizes[] | undefined
): ProductSizes | undefined {
  if (!sizes?.length) return undefined;
  return sizes.find(isRetailSize) ?? sizes[0];
}

/** Ảnh promotion: khớp primary size → default → thumbnail đầu. */
export function pickPromotionImagePath(product: Product): string {
  const primary = pickPrimaryProductSize(product.product_sizes);
  const thumbs = product.thumbnail;
  if (!thumbs?.length) return "";

  if (primary?.id != null) {
    const bySize = thumbs.find(
      (t) =>
        (t as ThumbnailRow).size_id != null &&
        (t as ThumbnailRow).size_id === primary.id
    );
    if (bySize?.image_path) return bySize.image_path;
  }

  const def = thumbs.find((t) => (t as ThumbnailRow).is_default === 1);
  if (def?.image_path) return def.image_path;

  return thumbs[0]?.image_path ?? "";
}
